import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminAppComponent } from 'modules/admin/admin-app.component';
import { AccessRestrictedComponent } from 'modules/shared/legacy-bookexpress/components/access-restricted/access-restricted.component';
import { Unavailable503Component } from './modules/shared/components/unavailable503/unavailable503.component';

export const appRoute: Routes = [
  {
    path: 'admin',
    component: AdminAppComponent,
    loadChildren: () => import('./modules/admin/admin-app.module').then((m) => m.AdminAppModule),
  },
  {
    path: 'cico',
    loadChildren: () => import('./modules/cico/cico.module').then((m) => m.CicoModule),
  },
  // {
  //   path: 'onecart',
  //   loadChildren: () => import('./modules/onecart/onecart.module').then((m) => m.OnecartModule),
  // },
  {
    path: 'wbe',
    loadChildren: () => import('./modules/book/legacy-components/book-legacy/book-legacy.module').then((m) => m.BookModule),
  },
  {
    path: 'golf',
    loadChildren: () => import('./modules/golf/legacy/components/golf-legacy/golf-legacy.module').then((m) => m.GolfLegacyModule),
  },
  {
    path: 'spa',
    loadChildren: () => import('./modules/spa/legacy/components/spa-legacy/spa-app.module').then((m) => m.SpaAppModule),
  },
  {
    path: 'accessRestricted/:tenant/:property',
    component: AccessRestrictedComponent,
  },
  {
    path: '404',
    component: Unavailable503Component,
  },
  {
    path: '**',
    redirectTo: '404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoute)],
})
export class AppRoutingModule {}
